import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import CustomTooltip from "components/CustomTooltip";

import {SyncStates} from "utils/ShippingMethods";

SyncStatusBadge.propTypes = {
    shippingMethod: PropTypes.object.isRequired
};

const colorBySyncState = {
    [SyncStates.PENDING]: 'default',
    [SyncStates.SYNCED]: 'online',
    [SyncStates.ERROR]: 'error',
};

// A failed push must show here, not only in the logs: the delivery promise shown at checkout comes from it.
function SyncStatusBadge({shippingMethod}) {
    // never pushed to Sylius, where it would become a checkout method
    if (shippingMethod.returnOnly) {
        return (
            <Badge rounded color={'info'}>
                <FormattedMessage id={'shippingMethods.sync.returnOnly'}/>
            </Badge>
        );
    }

    if (!shippingMethod.syncState) {
        return null;
    }

    const badge = (
        <Badge rounded color={colorBySyncState[shippingMethod.syncState] ?? 'default'}>
            <FormattedMessage id={`shippingMethods.sync.${shippingMethod.syncState}`}/>
        </Badge>
    );

    const errors = shippingMethod.lastPushErrors ?? [];

    if (SyncStates.ERROR !== shippingMethod.syncState || 0 === errors.length) {
        return badge;
    }

    return (
        <CustomTooltip title={<SyncErrors errors={errors} detail={shippingMethod.lastPushErrorDetail}/>} placement={'top'}>
            {/* focusable so keyboard users reach the error detail too; MUI links the tooltip via aria-describedby */}
            <span tabIndex={0}>{badge}</span>
        </CustomTooltip>
    );
}

// The API stores keys (App\Enum\ShippingMethod\SyncError), translated here; the detail is what Sylius answered, as is.
function SyncErrors({errors, detail}) {
    return (
        <>
            {errors.map(error => (
                <div key={error}>
                    <FormattedMessage
                        id={`shippingMethods.sync.error.${error}`}
                        defaultMessage={error}
                    />
                </div>
            ))}
            {detail && <div style={{fontWeight: 400, marginTop: '4px'}}>{detail}</div>}
        </>
    );
}

export default SyncStatusBadge;
